const MASTER_ROLES = new Set(["master", "admin"]);

export const normalizeEmail = (value: string | null | undefined) =>
  value?.trim().toLowerCase() ?? "";

export const hasMasterRole = (value: string | null | undefined) =>
  MASTER_ROLES.has(value?.trim().toLowerCase() ?? "");

export const normalizeUserRole = (value: string | null | undefined): "master" | "user" =>
  hasMasterRole(value) ? "master" : "user";

type ResolveMasterAccessInput = {
  profileRole?: string | null;
  fallbackProfileRole?: string | null;
  professionalType?: string | null;
  professionalRole?: string | null;
  metadataRole?: string | null;
};

// SECURITY: isMaster is derived exclusively from server-verified sources
// (profiles.role, user_roles, v_professionals). Email-based grants were
// removed to prevent client-side privilege escalation.
export const resolveMasterAccess = ({
  profileRole,
  fallbackProfileRole,
  professionalType,
  professionalRole,
  metadataRole,
}: ResolveMasterAccessInput) => {
  return (
    hasMasterRole(profileRole)
    || hasMasterRole(fallbackProfileRole)
    || hasMasterRole(professionalType)
    || hasMasterRole(professionalRole)
    || hasMasterRole(metadataRole)
  );
};
